package xyz.luan.bpc

import xyz.luan.bpc.calculator.Calculator
import xyz.luan.bpc.parser.Parser

object BPC {
    fun resolve(
        circles: List<String>,
        centre: String,
        markings: String,
    ): Double {
        val problem = Parser.parse(circles, centre, markings)
        return Calculator.process(problem)
    }
}
